import { Box, Typography, styled } from '@mui/material';
import { Linkable } from '@/components/blocks/Linkable';

export const DpArticleContainer = styled(Box)(({ theme }) => ({
	width: '100vw',
	paddingLeft: theme.spacing(2),
	paddingRight: theme.spacing(2),
	[theme.breakpoints.up('sm')]: {
		paddingLeft: theme.spacing(6),
		paddingRight: theme.spacing(6),
	},
}));

export const DpArticleContent = styled(Box)(({ theme }) => ({
	display: 'flex',
	justifyContent: 'center',
	flexDirection: 'column',
	gap: theme.spacing(2),
}));

export const DpArticleContentFrame = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	gap: theme.spacing(4),
	[theme.breakpoints.up('md')]: {
		flexDirection: 'row',
		gap: theme.spacing(10),
	},
	'& img': {
		maxWidth: '100%',
		[theme.breakpoints.up('md')]: {
			maxWidth: '500px',
		},
	},
}));

export const DpArticleTitle = styled((props) => <Typography {...props} component="h2" />)(
	({ theme }) => ({
		fontSize: 'var(--font-size-lg)',
		fontWeight: 800,
		[theme.breakpoints.up('sm')]: {
			fontSize: 'var(--font-size-xxl)',
		},
	})
);

export const DpArticleText = styled((props) => <Typography {...props} component="span" />)(
	({ theme }) => ({
		fontSize: 'var(--font-size-body)',
		[theme.breakpoints.up('sm')]: {
			fontSize: 'var(--font-size-sm)',
		},
	})
);

export const DpArticleContentTitle = styled(Typography)(({ theme }) => ({
	fontSize: 'var(--font-size-md)',
	fontWeight: 800,
	[theme.breakpoints.up('sm')]: {
		fontSize: 'var(--font-size-lg)',
	},
}));

export const DpArticleHeader = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'row',
	gap: theme.spacing(2),
	marginTop: theme.spacing(2),
	marginBottom: theme.spacing(2),
}));

export const DpArticleHeaderBack = styled(Linkable)({
	textDecoration: 'underline',
	fontSize: 'var(--font-size-body)',
	'&:hover': {
		color: 'primary.main',
	},
});

export const DpArticleHeaderCategory = styled(Typography)({
	fontSize: 'var(--font-size-body)',
	color: '#012966',
});
